var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensionCylindrical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 102,
    viewBox: "0 0 116 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#AFC2D6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 24,
    rx: 27,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 24V70C28 75.5 40 80 55 80C70 80 82 75.5 82 70V24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 70C28 64.5 40 60 55 60C70 60 82 64.5 82 70",
    strokeDasharray: "3 3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8FA7C1",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94 24V80M91 29L94 24L97 29M91 75L94 80L97 75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 90H82M33 87L28 90L33 93M77 87L82 90L77 93"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFD0E2",
    fontFamily: "Arial",
    fontSize: 11,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    x: 99,
    y: 55
  }, "H"), /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 101
  }, "D"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensionCylindrical);
export default __webpack_public_path__ + "static/media/dimension-cylindrical.20cff9c4f6b5ea56868113aa0ddacbdd.svg";
export { ForwardRef as ReactComponent };